import "./App.css";
import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./components/Homepage/HomePage";
import UnityComponent from "./components/UnityComponent/UnityComponent.js";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/system";
import theme from "./theme.js";
import EndGamePage from "./components/EndGamePage/EndGamePage";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ThankYou from "./components/ThankYou/ThankYou";
import { getCookie } from "./services/cookieService";
import {
  createUserWithScore,
  fetchUserById,
} from "./services/firestoreService";
import SignIn from "./components/SignIn/SignIn";
import UsersScores from "./components/UsersScores/UsersScores";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthContextProvider } from "./context/AuthContext";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { Box } from "@mui/material";
import RotateScreen from "./components/RotateScreen/RotateScreen";

function App() {
  const navigate = useNavigate();
  const [score, setScore] = useState(0);
  const [url, setUrl] = useState(null);
  const [innerHeight, setInnerHeight] = useState(0);

  useEffect(() => {
    const alfabetas = {
      3: "AhPxCImWyi",
      T: "6GixFEZkwe",
      G: "tNd43qGPap",
      p: "ZQVpDX6NqR",
      v: "JRp8D2HIt6",
      t: "BjNtRp51Or",
      i: "JcTS2zwLEj",
      S: "3g5Xbmiru7",
      R: "KGoRLlCHZp",
      Y: "Ej14PnHqOl",
    };

    const decryptScore = (input) => {
      let k = input.charAt(0);
      let alfabeta = alfabetas[k];
      if (alfabeta === undefined) throw new Error("k is invalid");
      let score = 0;
      for (let i = 1; i < input.length; i++) {
        let c = input.charAt(i);
        if (alfabeta.includes(c.toString()))
          score = score * 10 + alfabeta.indexOf(c);
      }
      return score;
    };

    const handleUnityMessage = async (event) => {
      if (event.origin === "https://firebasestorage.googleapis.com") {
        const gameScore = decryptScore(event.data);
        setScore(gameScore);
        const userId = getCookie("keff");
        if (!!userId) {
          const user = await fetchUserById(userId);
          if (!!user) {
            user["score"] = gameScore;
            createUserWithScore(user);
          }
          navigate("/thank-you");
        } else {
          navigate("/endGame");
        }
      }
    };

    const storage = getStorage();
    getDownloadURL(ref(storage, "game.html"))
      .then((gameUrl) => {
        setUrl(gameUrl);
      })
      .catch((err) => {
        console.error(err);
      });

    setInnerHeight(window.innerHeight);
    const handleResize = () => {
      if (innerHeight < window.innerHeight) {
        setInnerHeight(window.innerHeight);
      }
    };
    window.addEventListener("resize", handleResize);

    window.addEventListener("message", handleUnityMessage);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("message", handleUnityMessage);
    };
  }, []);

  return (
    <Box
      className="App"
      sx={{ height: innerHeight, boxSizing: "content-box", padding: 0 }}
    >
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <AuthContextProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
            <Route path="/game" element={<UnityComponent url={url} />} />
            <Route path="/login" element={<SignIn />} />
            {score && (
              <Route path="/endGame" element={<EndGamePage score={score} />} />
            )}
            {score && (
              <Route path="/thank-you" element={<ThankYou score={score} />} />
            )}
            <Route
              path="/scores"
              element={
                <ProtectedRoute>
                  <UsersScores />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthContextProvider>
        <RotateScreen />
      </ThemeProvider>
    </Box>
  );
}

export default App;
